import API from '@api/bi_nuo'
import commonApi from '@api/zhi_shui/commonApi'
import {
  chooseProperty,
  chooseType,
  freeShopEditStore,
  sidaGroup,
  sidaPersonal
} from '@constant'
import { appendUrlQuery, getUrlParam } from '@core/utils'
import { getObjValue } from '@hlj/hlj-utils'
import { __JWT__, __MAIN_JWT__ } from '@merchant-backend/constant'
import {
  getSessionMerchantInfo,
  isHonorable,
  isOnlineShop,
  isSiDaProperty,
  isUltimate
} from '@merchant-backend/util'
import { isWuDaProperty } from '@util'
import { message } from 'hljd'
import { action, observable, runInAction } from 'mobx'
import { hashHistory } from 'react-router'

class Store {
  @observable merchantInfo = {}
  /* 当前店铺是否已认证，为true则进入系统，否则去 merchant_register */
  @observable storesIsCertified = false

  initial = () => {
    this.merchantInfo = getSessionMerchantInfo()
    return new Promise(async resolve => {
      // const childCategoryNotFilled = this.checkChildCategoryNotFilled()

      // if (childCategoryNotFilled) {
      //   await this.getPropertyList()
      // } else {
      this.handleRender()
      // }

      resolve(this.storesIsCertified)
    })
  }

  // examine == -1 未填写二级类目
  checkChildCategoryNotFilled = () => {
    return this.merchantInfo.examine == -1
  }
  // parentStatus == 2 未填写店铺类型
  checkChildTypeNotFilled = () => {
    const isMainMerchant = this.merchantInfo.shop_type == 5
    const key = isMainMerchant ? __MAIN_JWT__ : __JWT__
    let jwtData = JSON.parse(localStorage.getItem(key) || null)

    return getObjValue(jwtData, 'parentStatus') == 2
  }

  /**
   * 新注册商家类型属于五大，提交了1+1信息且未开通线上店铺/旗舰版/尊享版
   */
  isJumpOnlineShopMarketing = () => {
    const { register_improve_submit_time, online_shop } = this.merchantInfo
    // 1+1信息提交了register_improve_submit_time有值
    //老的付费商家online_shop为0
    return (
      !!register_improve_submit_time &&
      isWuDaProperty() &&
      !isUltimate() &&
      !isOnlineShop() &&
      !isHonorable() &&
      online_shop != 0
    )
  }

  isCashierPage = () => {
    return window.location.hash.indexOf('#/cashier') > -1
  }

  handleRender = () => {
    // 服务商家
    if (this.isCashierPage()) {
      return (this.storesIsCertified = true)
    }
    // 去除线上商家服务费的跳转逻辑(仅根据服务端那边字段判断修改也可以实现，后续如果需要可以恢复)
    // if (this.isJumpOnlineShopMarketing()) {
    //   return (window.location.href = onLineShopMarket)
    // }
    if (this.checkChildTypeNotFilled()) {
      return (window.location.href = chooseType)
    }
    if (this.merchantInfo.shop_type == 0) {
      if (this.merchantInfo.property_id) {
        // 新商家
        if (this.merchantInfo.is_new == 1) {
          // if (
          //   this.merchantInfo.examine == 1 &&
          //   (this.merchantInfo.kind || this.merchantInfo.certify.status == 3)
          // ) {
          //   this.storesIsCertified = true
          // } else {
          // 盘古新注册可能不会有这个状态，增加兼容判断
          if (
            this.merchantInfo.certify.status == 0 ||
            !this.merchantInfo.certify.status
          ) {
            if (isSiDaProperty(this.merchantInfo.property_id)) {
              window.location.href =
                sidaPersonal + '?property_id=' + this.merchantInfo.property_id
            } else {
              window.location.href = freeShopEditStore
            }
          } else {
            this.storesIsCertified = true
          }
          // }
        }
        // 老商家
        else if (this.merchantInfo.is_new == 0) {
          if (this.merchantInfo.is_opened_trade == true) {
            this.storesIsCertified = true
          } else if (
            this.merchantInfo.certify.status == 0 ||
            !this.merchantInfo.certify.status
          ) {
            if (isSiDaProperty(this.merchantInfo.property_id)) {
              window.location.href =
                sidaPersonal + '?property_id=' + this.merchantInfo.property_id
            } else {
              window.location.href = freeShopEditStore
            }
          } else {
            this.storesIsCertified = true
          }
        }
      } else {
        window.location.href = chooseProperty + '?login_no_property=1'
      }
    }
    // 酒店
    else if (this.merchantInfo.shop_type == 3) {
      if (this.merchantInfo.is_new_hotel == 1) {
        // if (
        //   this.merchantInfo.examine == 1 &&
        //   this.merchantInfo.certify.status == 3
        // ) {
        //   this.storesIsCertified = true
        // } else {
        if (
          this.merchantInfo.examine == -1 ||
          this.merchantInfo.certify.status == 0
        ) {
          window.location.href = freeShopEditStore
        } else {
          this.storesIsCertified = true
        }
        // }
      } else {
        if (this.merchantInfo.examine != 1) {
          window.location.href = freeShopEditStore
        } else {
          this.storesIsCertified = true
        }
      }
    }
    // 服务商家主帐号
    else if (this.merchantInfo.shop_type == 5) {
      //服务商家主帐号
      if (isSiDaProperty(this.merchantInfo.property_id)) {
        // 团队账号进子账号后台
        if (
          this.merchantInfo.examine == -1 ||
          this.merchantInfo.certify.status == 0
        ) {
          window.location.href =
            sidaGroup + '?property_id=' + this.merchantInfo.property_id
        }
        //  else if (
        //   this.merchantInfo.examine != 1 &&
        //   (this.merchantInfo.status == 0 || this.merchantInfo.status == 1)
        // ) {
        //   window.location.href = freeShop
        // }
        else {
          this.storesIsCertified = true
        }
      }
    }
  }

  /* 经营品类列表 */
  @observable propertyList = []
  @observable certificationStep = '' //共计四种状态：noProperty、noCategory、noType、noOtherInfo
  @action
  getPropertyList = async () => {
    const { id } = this.merchantInfo
    const { success, data } = await API.getPropertyList({ merchant_id: id })
    const _data = data ? [data] : []
    if (success) {
      // 已选择类目, 直接进行完善信息
      if (!_data.length) {
        this.handleRender()
      } else {
        this.certificationStep = 'noCategory'
        this.propertyId = _data[0].id
        this.propertyList = _data
        this.storesIsCertified = true

        // 现只有 非四大 && 二级类目 进行选择，其他场景已在商家中心处理
        hashHistory.push({
          pathname: '/certificateStore'
        })
      }
    }
  }

  /* 选中经营品类 */
  @observable propertyId = ''
  @observable typeData = {}
  @action
  changeProperty = id => () => {
    this.propertyId = id
    this.categoryId = ''
  }
  @action
  checkProperty = () => {
    const { propertyId } = this
    if (!propertyId) {
      return message.warning('请先选择类目')
    }
    let link = ''
    if (propertyId == 'hunche') {
      this.showWeddingCarModal()
    } else if (
      propertyId == 6 ||
      propertyId == 12 ||
      propertyId == 15 ||
      propertyId == 13
    ) {
      this.certificationStep = 'noCategory'
    } else if (propertyId == 7 || propertyId == 8 || propertyId == 9) {
      this.certificationStep = 'noType'
      this.typeData =
        (this.propertyList.find(item => item.id == propertyId) || {})
          .four_role_tips || []
    } else {
      this.certificationStep = 'noOtherInfo'
      link =
        '/p/frontend/merchant-center/dist/index.html#/freeShop/register?property_id=' +
        this.propertyId +
        '&fromRegister=1'
      this.sendCertificateStoreInfo(() => {
        this.isBDAndJump(link)
      })
    }
  }

  /* 是否是bd并跳转 */
  isBDAndJump(link) {
    const is_bd = getUrlParam('is_bd')
    if (is_bd) {
      window.location.href = link + '&is_bd=1'
    } else {
      window.location.href = link
    }
  }

  /* 选择非四大子类 */
  @observable categoryList = []
  @action
  getCategoryList = () => {
    const { propertyId, propertyList } = this
    this.categoryList =
      (propertyList.find(item => item.id == propertyId) || {}).children || []
  }
  @observable categoryId = ''
  @action
  changeCategory = id => () => {
    this.categoryId = id
  }
  @action
  checkCategory = () => {
    const { propertyId, categoryId } = this

    if (!categoryId && categoryId !== 0) {
      return message.warning('请先选择类目')
    }

    let category_id
    if (categoryId == 999999) {
      category_id = ''
    } else {
      category_id = categoryId
    }

    this.sendCertificateStoreInfo(() => {
      this.isBDAndJump(
        appendUrlQuery(freeShopEditStore, {
          category_id,
          property_id: propertyId,
          fromRegister: 1
        })
      )
    })
  }

  @action
  sendCertificateStoreInfo = async (
    callback,
    params = {
      property_id: this.propertyId,
      category_id: this.categoryId
    }
  ) => {
    const { success } = await API.editFromMerchantCenter(params)
    if (success) {
      typeof callback === 'function' && callback()
    }
  }

  /* 婚车类 */
  @observable weddingCarModalVisible = false
  @observable weddingCarModalLoading = false

  @action
  showWeddingCarModal = () => {
    this.weddingCarModalVisible = true
  }
  @action
  cancelWeddingCarModal = () => {
    this.weddingCarModalVisible = false
    this.weddingCarModalLoading = false
  }

  @action
  submitWeddingCar = async params => {
    this.weddingCarModalLoading = true
    const shop_area_id = params['shop_area_id'].slice(-1)[0]
    params = Object.assign({}, params, { shop_area_id })
    const { success } = await API.enterCarJob(params)
    if (success) {
      message.success('「成功提交婚车入驻申请」')
      this.cancelWeddingCarModal()
      this.sendCertificateStoreInfo(null)
    }
  }

  /* 地址选择 */
  @observable allAddress = []
  @action
  async getAllAddress() {
    let { data = [] } = await commonApi.getPCCApi()
    let allCity = data.map(item => {
      let city = {
        value: item.id,
        label: item.area_name,
        key: item.id
      }
      if (item.children) {
        city.children = item.children.map(item => ({
          value: item.id,
          label: item.area_name,
          key: item.id,
          children: item.children
        }))
        for (let i in city.children[0].children) {
          if (city.children[i]) {
            city.children[i].children = city.children[i].children.map(item => ({
              value: item.id,
              label: item.area_name,
              key: item.id
            }))
          }
        }
      }
      return city
    })
    runInAction('list', () => {
      this.allAddress = allCity
    })
  }
}
export default new Store()
